import { AutogenLayoutProspectSummary } from "./autogen/AutogenLayoutProspectSummary";

export class ProspectSummary extends AutogenLayoutProspectSummary {
    private _prospectId: string;

    onLoad(): void | Promise<void> {
        this.textboxLastCompletedActivity.quickInfoOverrideSearchMethod = async (layout, keyValue) => {
            if (!this.activeRow.isNull(this.textboxLastCompletedActivity.field)) {
                await layout.search({ "id": this.activeRow.get("id"), "type": "P" });
            }
        }
    }
    
    get prospectId(): string {
        return this._prospectId;
    }

    set prospectId(value: string) {
        this._prospectId = value;
        this.sourceProspectSummary.search({"id": value});
    }
}